(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yd-collection-bottom-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-yd-load-more]');

    roots.forEach((root) => {
      if (root.dataset.ydInitialized === 'true') return;
      root.dataset.ydInitialized = 'true';

      const button = root.querySelector('[data-yd-load-more-button]');
      if (!(button instanceof HTMLAnchorElement)) return;

      let syncing = false;

      const getResults = () => document.querySelector('results-list.product-grid-container[section-id]');
      const getGrid = () => getResults()?.querySelector('[ref="grid"]');

      const getPageState = () => {
        const grid = getGrid();
        const cards = grid ? Array.from(grid.querySelectorAll(':scope > [ref="cards[]"]')) : [];
        const pages = Number(grid?.dataset.lastPage || 1);
        let highestPage = 1;

        cards.forEach((card) => {
          highestPage = Math.max(highestPage, Number(card.dataset.page || 1));
        });

        return { grid, pages, highestPage };
      };

      const sync = () => {
        if (syncing) return;
        syncing = true;

        requestAnimationFrame(() => {
          syncing = false;
          const state = getPageState();
          if (!state.grid) return;

          const isFinished = state.pages <= 1 || state.highestPage >= state.pages;
          root.hidden = isFinished;
          button.hidden = isFinished;

          if (!isFinished) {
            const nextUrl = new URL(window.location.href);
            nextUrl.searchParams.set('page', String(state.highestPage + 1));
            nextUrl.searchParams.delete('section_id');
            nextUrl.hash = '';
            button.href = nextUrl.toString();
          }
        });
      };

      button.addEventListener('click', async (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (button.getAttribute('aria-busy') === 'true') return;

        const results = getResults();
        const grid = getGrid();
        const sectionId = results?.getAttribute('section-id');

        if (!grid || !sectionId) {
          window.location.href = button.href;
          return;
        }

        const originalLabel = button.textContent.trim();
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Loading…';

        const requestUrl = new URL(button.href);
        requestUrl.searchParams.set('section_id', sectionId);

        try {
          const response = await fetch(requestUrl.toString(), { credentials: 'same-origin' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextGrid = doc.querySelector('[ref="grid"]');
          if (!nextGrid) throw new Error('Product grid not found');

          const existingIds = new Set(
            Array.from(grid.querySelectorAll(':scope > [ref="cards[]"]')).map((card) => card.dataset.productId)
          );

          const newCards = Array.from(nextGrid.querySelectorAll(':scope > [ref="cards[]"]')).filter(
            (card) => !existingIds.has(card.dataset.productId)
          );

          if (newCards.length === 0) throw new Error('No additional products found');

          grid.append(...newCards);
          sync();
        } catch (error) {
          console.warn('View more failed, falling back to pagination.', error);
          window.location.href = button.href;
          return;
        } finally {
          button.removeAttribute('aria-busy');
          button.textContent = originalLabel;
        }
      });

      const results = getResults();
      if (results) {
        const observer = new MutationObserver(sync);
        observer.observe(results, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-last-page'],
        });
      }

      window.addEventListener('popstate', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yd-collection-load-more"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-yd-load-more]');

    roots.forEach((root) => {
      if (root.dataset.ydInitialized === 'true') return;
      root.dataset.ydInitialized = 'true';

      const button = root.querySelector('[data-yd-load-more-button]');
      const viewedNode = root.querySelector('[data-yd-viewed]');
      const totalNode = root.querySelector('[data-yd-total]');
      const progressNode = root.querySelector('[data-yd-progress]');
      const collectionTotal = Number(root.dataset.collectionTotal || 0);

      if (!(button instanceof HTMLAnchorElement)) return;

      let syncing = false;
      let filteredTotalRequest = 0;

      const getResults = () => document.querySelector('results-list[section-id]');
      const getGrid = () => getResults()?.querySelector('[ref="grid"]');

      const getCards = () => {
        const grid = getGrid();
        return grid ? Array.from(grid.querySelectorAll(':scope > [ref="cards[]"]')) : [];
      };

      const getPageState = () => {
        const grid = getGrid();
        const cards = getCards();
        const pages = Number(grid?.dataset.lastPage || 1);
        const pageCounts = new Map();
        let highestPage = 1;

        cards.forEach((card) => {
          const page = Number(card.dataset.page || 1);
          highestPage = Math.max(highestPage, page);
          pageCounts.set(page, (pageCounts.get(page) || 0) + 1);
        });

        const pageSize = Math.max(1, ...pageCounts.values());

        return { grid, cards, pages, highestPage, pageSize };
      };

      const hasActiveFilters = () => {
        const url = new URL(window.location.href);
        return Array.from(url.searchParams.keys()).some((key) => key.startsWith('filter.'));
      };

      const filterKey = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        return `${url.pathname}?${url.searchParams.toString()}`;
      };

      const setProgress = (viewed, total) => {
        if (viewedNode) viewedNode.textContent = String(viewed);
        if (totalNode) totalNode.textContent = String(total);
        if (progressNode) {
          const percent = total > 0 ? Math.min(100, (viewed / total) * 100) : 100;
          progressNode.style.width = `${percent}%`;
        }
      };

      const resolveFilteredTotal = async (state, key) => {
        if (state.pages <= 1) {
          root.dataset.filteredKey = key;
          root.dataset.filteredTotal = String(state.cards.length);
          setProgress(state.cards.length, state.cards.length);
          return;
        }

        if (root.dataset.filteredKey === key && root.dataset.filteredTotal) {
          setProgress(state.cards.length, Number(root.dataset.filteredTotal));
          return;
        }

        const requestId = ++filteredTotalRequest;
        const results = getResults();
        const sectionId = results?.getAttribute('section-id');
        if (!sectionId) return;

        const url = new URL(window.location.href);
        url.searchParams.set('page', String(state.pages));
        url.searchParams.set('section_id', sectionId);
        url.hash = '';

        try {
          const response = await fetch(url.toString(), { credentials: 'same-origin' });
          if (!response.ok) return;

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const lastGrid = doc.querySelector('[ref="grid"]');
          const lastCount = lastGrid
            ? lastGrid.querySelectorAll(':scope > [ref="cards[]"]').length
            : 0;
          const total = (state.pages - 1) * state.pageSize + lastCount;

          if (requestId !== filteredTotalRequest || filterKey() !== key || total <= 0) return;

          root.dataset.filteredKey = key;
          root.dataset.filteredTotal = String(total);
          setProgress(getCards().length, total);
        } catch (error) {
          console.warn('Unable to resolve filtered collection total.', error);
        }
      };

      const sync = () => {
        if (syncing) return;
        syncing = true;

        requestAnimationFrame(() => {
          syncing = false;
          const state = getPageState();
          if (!state.grid) return;

          if (state.pages <= 1 || state.highestPage >= state.pages) {
            root.hidden = state.pages <= 1;
            button.hidden = state.highestPage >= state.pages;
          } else {
            root.hidden = false;
            button.hidden = false;
          }

          const nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set('page', String(state.highestPage + 1));
          nextUrl.searchParams.delete('section_id');
          nextUrl.hash = '';
          button.href = nextUrl.toString();

          if (hasActiveFilters()) {
            const key = filterKey();
            if (root.dataset.filteredKey === key && root.dataset.filteredTotal) {
              setProgress(state.cards.length, Number(root.dataset.filteredTotal));
            } else {
              resolveFilteredTotal(state, key);
            }
          } else {
            root.dataset.filteredKey = '';
            root.dataset.filteredTotal = '';
            setProgress(state.cards.length, collectionTotal);
          }
        });
      };

      button.addEventListener('click', async (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (button.getAttribute('aria-busy') === 'true') return;

        const results = getResults();
        const grid = getGrid();
        const sectionId = results?.getAttribute('section-id');
        if (!grid || !sectionId) {
          window.location.href = button.href;
          return;
        }

        const originalLabel = button.textContent.trim();
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Loading…';

        const requestUrl = new URL(button.href);
        requestUrl.searchParams.set('section_id', sectionId);

        try {
          const response = await fetch(requestUrl.toString(), { credentials: 'same-origin' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextGrid = doc.querySelector('[ref="grid"]');
          if (!nextGrid) throw new Error('Product grid not found');

          const existingIds = new Set(
            Array.from(grid.querySelectorAll(':scope > [ref="cards[]"]')).map((card) => card.dataset.productId)
          );
          const newCards = Array.from(nextGrid.querySelectorAll(':scope > [ref="cards[]"]')).filter(
            (card) => !existingIds.has(card.dataset.productId)
          );

          if (newCards.length === 0) throw new Error('No additional products found');

          grid.append(...newCards);
          sync();
        } catch (error) {
          console.warn('Load more failed, falling back to pagination.', error);
          window.location.href = button.href;
          return;
        } finally {
          button.removeAttribute('aria-busy');
          button.textContent = originalLabel;
        }
      });

      const results = getResults();
      if (results) {
        const observer = new MutationObserver(sync);
        observer.observe(results, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-last-page'],
        });
      }

      window.addEventListener('popstate', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
